/**
 * Converte um timestamp da API em Date, interpretando-o como UTC.
 *
 * O backend grava `DateTime.UtcNow` e serializa sem sufixo de fuso
 * ("2026-08-03T18:15:32.2035001"). Sem o "Z", o JS lê a string como horário
 * LOCAL — exibindo 18:15 onde na verdade eram 15:15 em Brasília, e jogando o
 * tempo relativo 3 horas para o futuro.
 *
 * Strings que já trazem "Z" ou offset passam intactas, então isto continua
 * correto se um dia o backend passar a serializar o fuso.
 */
export function parseDataApi(iso: string): Date {
  const temFuso = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(iso);
  // Só timestamps (com "T") recebem o sufixo; datas puras ("2026-08-03") já
  // são interpretadas como UTC pelo próprio JS e ficariam inválidas com "Z".
  const precisaUtc = iso.includes("T") && !temFuso;
  return new Date(precisaUtc ? `${iso}Z` : iso);
}

/** Tempo relativo em pt-BR: "agora mesmo", "há 3 minutos", "há 2 horas", "há 5 dias". */
export function formatarTempoRelativo(iso: string): string {
  const data = parseDataApi(iso);
  const diffMs = data.getTime() - Date.now();
  const abs = Math.abs(diffMs);
  const min = 60 * 1000;
  const hora = 60 * min;
  const dia = 24 * hora;
  const rtf = new Intl.RelativeTimeFormat("pt-BR", { numeric: "auto" });
  if (abs < min) return "agora mesmo";
  if (abs < hora) return rtf.format(Math.round(diffMs / min), "minute");
  if (abs < dia) return rtf.format(Math.round(diffMs / hora), "hour");
  if (abs < 30 * dia) return rtf.format(Math.round(diffMs / dia), "day");
  return data.toLocaleDateString("pt-BR");
}
